import { render, staticRenderFns } from "./career.vue?vue&type=template&id=52ff9970&scoped=true&"
import script from "./career.vue?vue&type=script&lang=js&"
export * from "./career.vue?vue&type=script&lang=js&"
import style0 from "./career.vue?vue&type=style&index=0&id=52ff9970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff9970",
  null
  
)

export default component.exports